import React from "react";
import Container from "../Component/Container";
import Header from "../Component/Header";

export default function Home() {
  return (
    <div>
      <Header />
      <Container />
    </div>
  );
}
